// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agmAwlR0WHcXz6XJF_DL{--titled-row-action-width:180px;flex-direction:column;display:flex}.VCSpUHInBDYrYDe63Rgz{grid-template-columns:1fr 1fr;gap:16px;display:grid}.zCkGHbWbcw4BHdxGP3bO{border:1px solid var(--border-neutral-default);border-radius:12px;flex-direction:column;width:100%;padding:16px;display:flex}.bmexm3YogkXiiSxZRrST{line-height:1.5}.BRut3Mn0NNUvxrQ9xIMH{gap:4px;margin-bottom:12px;display:flex}.A05FAGSh4NrR9Ssv_iWg{flex-direction:column;gap:36px;margin-top:24px;display:flex}.v8977oTxPUcKABgrRvfG{width:100%}.Sd3TZq1FQMYjJx295GXw{--dropdown-checked-margin-left:5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `agmAwlR0WHcXz6XJF_DL`,
	"info": `VCSpUHInBDYrYDe63Rgz`,
	"block": `zCkGHbWbcw4BHdxGP3bO`,
	"label": `bmexm3YogkXiiSxZRrST`,
	"subtitle": `BRut3Mn0NNUvxrQ9xIMH`,
	"control": `A05FAGSh4NrR9Ssv_iWg`,
	"select": `v8977oTxPUcKABgrRvfG`,
	"dropdown": `Sd3TZq1FQMYjJx295GXw`
};
export default ___CSS_LOADER_EXPORT___;
